"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var core_1 = require("@material-ui/core");

var autobind_decorator_1 = __importDefault(require("autobind-decorator"));

var react_redux_1 = require("react-redux");

var datatableAction_1 = require("./redux/datatableAction");

var localStorage_1 = require("../utils/localStorage");

var DatatableContext = React.createContext({});

exports.datatableConsumer = function (Component) {
  return function (props) {
    return React.createElement(DatatableContext.Consumer, null, function (ctx) {
      return React.createElement(Component, __assign({}, props, ctx));
    });
  };
};

var Datatable =
/** @class */
function (_super) {
  __extends(Datatable, _super);

  function Datatable(props) {
    var _this = _super.call(this, props) || this;

    _this.storage = new localStorage_1.LocalStorageEntity('datatable_columns_' + props.name);
    _this.state = {
      name: props.name,
      actions: new datatableAction_1.PaginateAction(props.name, props.action),
      selected: [],
      onSelect: props.onSelect && _this.handleSelect,
      columns: [],
      publishColumns: _this.handlePublishColumns,
      hiddenColumnsIndexes: _this.storage.load() || [],
      onToggleColumnVisibility: _this.ToggleColumnVisibility,
      isColumnVisible: _this.isColumnVisible,
      expendRow: _this.expendRow
    };
    return _this;
  }

  Datatable.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        isFetching = _a.isFetching,
        toolbar = _a.toolbar,
        criteria = _a.criteria,
        size = _a.size,
        page = _a.page,
        className = _a.className,
        style = _a.style;
    return React.createElement(DatatableContext.Provider, {
      value: this.state
    }, React.createElement("div", {
      className: className,
      style: style
    }, toolbar, React.createElement("div", {
      style: {
        overflowX: 'auto',
        overflowY: 'hidden',
        width: '100%',
        position: 'relative'
      }
    }, isFetching && React.createElement(core_1.LinearProgress, {
      style: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0
      }
    }), React.createElement(core_1.Table, {
      style: {
        borderCollapse: 'initial'
        /* Fix bug when apply transform on <tr> */

      }
    }, children)), React.createElement(core_1.Table, null, React.createElement(core_1.TableBody, null, React.createElement(core_1.TableRow, null, React.createElement(core_1.TablePagination, {
      count: size || 0,
      rowsPerPage: criteria.limit,
      page: page,
      onChangePage: this.handleChangePage,
      onChangeRowsPerPage: this.handleChangeRowsPerPage
    }))))));
  };

  Datatable.prototype.componentDidMount = function () {
    var data = this.props.data;
    if (!data) this.search();
  };

  Datatable.prototype.search = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a, dispatch, criteria, action;

      return __generator(this, function (_b) {
        _a = this.props, dispatch = _a.dispatch, criteria = _a.criteria, action = _a.action; // TODO Handle progress and error

        dispatch(action(criteria));
        return [2
        /*return*/
        ];
      });
    });
  };

  Datatable.prototype.handleChangeRowsPerPage = function (event) {
    var dispatch = this.props.dispatch;
    this.resetExpendedRow();
    if (this.state.actions) dispatch(this.state.actions.updateCriteria('limit', event.target.value));
  };

  Datatable.prototype.handleSortChange = function (sortBy, orderBy) {
    this.resetExpendedRow();
    var dispatch = this.props.dispatch;
    dispatch(this.state.actions.sort(sortBy, orderBy));
  };

  Datatable.prototype.handleChangePage = function (e, newPage) {
    this.resetExpendedRow();
    var dispatch = this.props.dispatch;
    if (this.state.actions) dispatch(this.state.actions.goToPage(newPage));
  };

  Datatable.prototype.handleSelect = function (selected) {
    var onSelect = this.props.onSelect;
    this.setState({
      selected: selected
    });
    if (onSelect) onSelect(selected);
  };

  Datatable.prototype.handlePublishColumns = function (columns) {
    this.setState({
      columns: columns
    });
  };

  Datatable.prototype.isColumnVisible = function (i) {
    var hiddenColumnsIndexes = this.state.hiddenColumnsIndexes;
    return !hiddenColumnsIndexes[i];
  };

  Datatable.prototype.ToggleColumnVisibility = function (i) {
    var hiddenColumnsIndexes = this.state.hiddenColumnsIndexes;
    hiddenColumnsIndexes[i] = !hiddenColumnsIndexes[i];
    this.setState({
      hiddenColumnsIndexes: hiddenColumnsIndexes.slice()
    }, this.persistHiddenColumns);
  };

  Datatable.prototype.expendRow = function (id) {
    this.setState(function (state) {
      return {
        expendedRowIndex: state.expendedRowIndex !== id ? id : undefined
      };
    });
  };

  Datatable.prototype.resetExpendedRow = function () {
    if (this.state.expendedRowIndex) this.setState({
      expendedRowIndex: undefined
    });
  };

  Datatable.prototype.persistHiddenColumns = function () {
    this.storage.save(this.state.hiddenColumnsIndexes);
  };

  __decorate([autobind_decorator_1.default], Datatable.prototype, "handleChangeRowsPerPage", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "handleSortChange", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "handleChangePage", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "handleSelect", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "handlePublishColumns", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "isColumnVisible", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "ToggleColumnVisibility", null);

  __decorate([autobind_decorator_1.default], Datatable.prototype, "expendRow", null);

  return Datatable;
}(React.Component);

var state2props = function state2props(state, ownProps) {
  var paginateState = state.paginate[ownProps.name];
  return {
    isFetching: paginateState.isFetching,
    page: paginateState.criteria.offset / paginateState.criteria.limit,
    criteria: paginateState.criteria,
    size: paginateState.total_size,
    data: paginateState.entities
  };
};

exports.default = react_redux_1.connect(state2props)(Datatable);